import PropTypes from "prop-types";

import { annotationPropType } from "@/view/viewPropTypes";
import ColorPicker from "@/view/ColorPicker";
import AnnotationActions from "../Actions/AnnotationActions";
import AnnotationCardAnnotatedText from "../AnnotationCardAnnotatedText";
import AnnotationShareStatus from "../AnnotationShareStatus";
import AnnotationText from "../AnnotationText";
import AnnotationTextArea from "../AnnotationTextArea";
import StaticColorIndicator from "../StaticColorIndicator";
import {
  annotationCss,
  indicatorContainerCss,
} from "./AnnotationCardContents.style";

const propTypes = {
  annotation: annotationPropType,
  focusContentBodyAnnotation: PropTypes.func,
  handleCancel: PropTypes.func,
  handleColorChange: PropTypes.func,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  handleShare: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleTextChange: PropTypes.func,
  highlightedText: PropTypes.arrayOf(
    PropTypes.shape({
      endOffset: PropTypes.number.isRequired,
      identifier: PropTypes.string,
      parentIdentifier: PropTypes.string.isRequired,
      startOffset: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  isActionPending: PropTypes.bool,
  isDraft: PropTypes.bool,
  isEditMode: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isShared: PropTypes.bool,
  isStudent: PropTypes.bool,
  isTeacher: PropTypes.bool,
  numberOfCommentsInThread: PropTypes.number,
  selectedRadioButtonRef: PropTypes.object,
  setIsExpanded: PropTypes.func,
  updatedAnnotation: PropTypes.object,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const AnnotationCardContents = ({
  annotation,
  focusContentBodyAnnotation,
  handleCancel,
  handleColorChange,
  handleDelete,
  handleEdit,
  handleShare,
  handleSubmit,
  handleTextChange,
  highlightedText,
  isActionPending,
  isDraft,
  isEditMode,
  isExpanded,
  isShared,
  isStudent,
  isTeacher,
  numberOfCommentsInThread,
  selectedRadioButtonRef,
  setIsExpanded,
  updatedAnnotation,
  userId,
}) => {
  const { pen_name: penName, user, text } = annotation;
  const cardIsExpandedAndIsDraftOrIsCurrentUser =
    isExpanded && (isDraft || userId === user.id);

  const renderColorPickerComponent = () => {
    if (isEditMode) {
      return (
        <ColorPicker
          selectedColor={updatedAnnotation.pen_name}
          selectedRadioButtonRef={selectedRadioButtonRef}
          handleOnChange={handleColorChange}
        />
      );
    }

    return (
      <div css={indicatorContainerCss}>
        <StaticColorIndicator penName={penName} />
        {isTeacher && (
          <AnnotationShareStatus
            isShared={isShared}
            hasReplies={annotation.hasReplies}
          />
        )}
      </div>
    );
  };

  const renderActions = () => {
    return (
      <AnnotationActions
        annotationId={annotation.id}
        isActionPending={isActionPending}
        isDraft={isDraft}
        isEditMode={isEditMode}
        isShared={isShared}
        isTeacher={isTeacher}
        handleCancel={handleCancel}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        handleShare={handleShare}
        handleSubmit={handleSubmit}
        hasReplies={annotation.hasReplies}
      />
    );
  };

  const renderAnnotationText = () => {
    return (
      <div>
        <AnnotationText
          firstName={user.first_name}
          isExpanded={isExpanded}
          isStudent={isStudent}
          lastName={user.last_name}
          numberOfCommentsInThread={numberOfCommentsInThread}
          setIsExpanded={setIsExpanded}
          text={text}
        />
        {cardIsExpandedAndIsDraftOrIsCurrentUser &&
          !numberOfCommentsInThread &&
          renderActions()}
      </div>
    );
  };

  const renderTextArea = () => {
    return (
      <form>
        <AnnotationTextArea
          handleOnChange={handleTextChange}
          text={updatedAnnotation.text}
        />
        {cardIsExpandedAndIsDraftOrIsCurrentUser && renderActions()}
      </form>
    );
  };

  return (
    <>
      {renderColorPickerComponent()}
      <div css={annotationCss}>
        <AnnotationCardAnnotatedText
          annotation={updatedAnnotation}
          focusContentBodyAnnotation={focusContentBodyAnnotation}
          highlightedText={highlightedText}
          isGradingPage={false}
        />
      </div>
      {isEditMode ? renderTextArea() : renderAnnotationText()}
    </>
  );
};

AnnotationCardContents.propTypes = propTypes;
export default AnnotationCardContents;
